import TabGroupBoleto from '@/components/molecules/TabGroupBoleto';
import { BoletoTabs } from '@/data/misc/boleto-tabs';

export default function BoletoPage() {
  return <TabGroupBoleto tab={BoletoTabs.boleto.id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
